module.exports = __webpack_public_path__ + "img/repair_request_red.e55cf1e6.svg";